import { render, staticRenderFns } from "./upstreamCollectionIndex.vue?vue&type=template&id=3c9797bf&scoped=true"
import script from "./upstreamCollectionIndex.vue?vue&type=script&lang=js"
export * from "./upstreamCollectionIndex.vue?vue&type=script&lang=js"
import style0 from "./upstreamCollectionIndex.vue?vue&type=style&index=0&id=3c9797bf&prod&scoped=true&lang=css"
import style1 from "./upstreamCollectionIndex.vue?vue&type=style&index=1&id=3c9797bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9797bf",
  null
  
)

export default component.exports